import React, { useContext, useEffect, useState } from "react";
import studyviewerContext from "../studyviewer/StudyviewerContext";
import ShareStudyContext from "../sharestudy/ShareStudyContext";
import ShareStudyLink from "../../pages/StudyList/components/Actions/ShareStudyLink";
import { shareStudyLinkApi, shareStudyToUsersApi } from "../../service/StudyListService";
import loaderContext from "../loader/LoaderContext";
import ToastState from "../toast/ToastState";
import { TOAST_TYPE } from "../../constants/Constants";
import toastContext from "../toast/ToastContext";
import { t } from "i18next";

const ShareStudyState = (props) => {

  // const { studyParentId, showToast, setShowToast, assignmentData} =
  //   useContext(studyviewerContext);

  const {ref, setLoaderRunning} = useContext(loaderContext);
  const {showToastv2} = useContext(toastContext);

  const [studyShareUrl, setStudyShareUrl] = useState("");
  const [showShareStudyLinkModal, setShowShareStudyLinkModal] = useState(false);

  const fetchShareStudyUrl = async (studyId, firmId, clientId) => {
    console.log('studyid =====', studyId);
    console.log('firmId =====', firmId);
    console.log('clientId ====', clientId);
    setLoaderRunning(true);
    ref.current.continuousStart()
    const response = await shareStudyLinkApi(studyId, firmId, clientId);
    if (response.data.result === "SUCCESS") {
      setLoaderRunning(false);
      ref.current.complete();
      setStudyShareUrl(response.data.data);
      // setShowShareStudyLinkModal(true);
      // setShowToast((prev) => {
      //   return {
      //     ...prev,
      //     show: false,
      //     message: "",
      //     loading: false,
      //     state: "success",
      //   };
      // });
    } else {
      setLoaderRunning(false);
      ref.current.complete();
      setShowShareStudyLinkModal(false);
      // setShowToast((prev) => {
      //   return {
      //     ...prev,
      //     show: true,
      //     message: "Error while fetching study url",
      //     loading: false,
      //     state: "error",
      //   };
      // });
      showToastv2(TOAST_TYPE.SUCCESS, "Study shared successfully");
    }
  };

    const shareStudyByMail = async(payload) =>{
        setLoaderRunning(true);
        ref.current.continuousStart()
        // setShowToast((prev) => {
        //     return {
        //     ...prev,
        //     show: false,
        //     message: "",
        //     loading: true,
        //     state: "success",
        //     };
        // });
        setShowShareStudyLinkModal(false); // this will be called only from studyviewr
        const response = await shareStudyToUsersApi(payload);
        if(response.data.result == "SUCCESS"){
          setLoaderRunning(false);
          ref.current.complete();
          showToastv2(TOAST_TYPE.SUCCESS, t("share-study.shared-successfully"))
            // setShowToast((prev) => {
            //     return {
            //     ...prev,
            //     show: true,
            //     message: "Study shared successfully",
            //     loading: false,
            //     state: "success",
            //     };
            // });
        }
        else {
          setLoaderRunning(false);
          ref.current.complete();
          showToastv2(TOAST_TYPE.ERROR, t("share-study.error-share-study"));
        }
    }

  return (
    <ShareStudyContext.Provider
      value={{
        studyShareUrl,
        setStudyShareUrl,
        fetchShareStudyUrl,
        showShareStudyLinkModal,
        setShowShareStudyLinkModal,
        shareStudyByMail,
      }}
    >
      {props.children}
    </ShareStudyContext.Provider>
  );
};

export default ShareStudyState;
